import React from 'react';
import { MessageCircle, Phone, Instagram, Mail, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  const whatsappNumber = "18099640099";
  const whatsappMessage = "Hola, me gustaría obtener más información sobre el alquiler de vehículos";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section id="contacto" className="py-20 md:py-32 bg-zinc-950 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(255,255,255,0.1) 1px, transparent 80px),
                           repeating-linear-gradient(-90deg, transparent, transparent 1px, rgba(255,255,255,0.1) 1px, transparent 80px)`
        }}></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-yellow-700/20 border border-yellow-600/30 px-4 py-2 mb-6">
              <span className="text-yellow-600 text-sm font-medium">CONTÁCTANOS</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              ¿Listo para tu Aventura?
            </h2>
            <p className="text-xl text-white/80 mb-8 leading-relaxed">
              Estamos aquí para ayudarte. Contáctanos por WhatsApp y reserva tu vehículo 
              en minutos. Nuestro equipo está disponible 24/7 para atenderte.
            </p>

            {/* Contact Methods */}
            <div className="space-y-6 mb-10">
              <a 
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-black border border-white/10 p-6 hover:border-yellow-600/50 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-yellow-700/20 border border-yellow-600/30 flex items-center justify-center group-hover:bg-yellow-700 transition-colors duration-300">
                  <MessageCircle className="w-7 h-7 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">WhatsApp (Preferido)</div>
                  <div className="text-white font-semibold text-lg">+1 (809) 964-0099</div>
                </div>
              </a>

              <a 
                href="tel:+18099640099"
                className="flex items-center gap-4 bg-black border border-white/10 p-6 hover:border-yellow-600/50 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-yellow-700/20 border border-yellow-600/30 flex items-center justify-center group-hover:bg-yellow-700 transition-colors duration-300">
                  <Phone className="w-7 h-7 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">Teléfono</div>
                  <div className="text-white font-semibold text-lg">+1 (809) 964-0099</div>
                </div>
              </a>

              <a 
                href="https://instagram.com/rentcardelaisla"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-black border border-white/10 p-6 hover:border-yellow-600/50 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-yellow-700/20 border border-yellow-600/30 flex items-center justify-center group-hover:bg-yellow-700 transition-colors duration-300">
                  <Instagram className="w-7 h-7 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">Instagram</div>
                  <div className="text-white font-semibold text-lg">@rentcardelaisla</div>
                </div>
              </a>

              <a 
                href="mailto:larentcardelaisla@gmail.com"
                className="flex items-center gap-4 bg-black border border-white/10 p-6 hover:border-yellow-600/50 transition-all duration-300 group"
              >
                <div className="w-14 h-14 bg-yellow-700/20 border border-yellow-600/30 flex items-center justify-center group-hover:bg-yellow-700 transition-colors duration-300">
                  <Mail className="w-7 h-7 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <div>
                  <div className="text-white/60 text-sm mb-1">Email</div>
                  <div className="text-white font-semibold text-sm">larentcardelaisla@gmail.com</div>
                </div>
              </a>
            </div>

            {/* Additional Info */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <Clock className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" />
                <div>
                  <div className="text-white font-semibold mb-1">Horario</div>
                  <div className="text-white/70 text-sm">Disponible 24/7</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" />
                <div>
                  <div className="text-white font-semibold mb-1">Cobertura</div>
                  <div className="text-white/70 text-sm">Todo el país</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - CTA Box */}
          <div className="bg-yellow-700 p-10 md:p-12 lg:p-16">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Reserva Ahora y Obtén
            </h3>
            <ul className="space-y-4 mb-10">
              <li className="flex items-start gap-3 text-white">
                <div className="w-6 h-6 bg-white text-yellow-700 flex items-center justify-center flex-shrink-0 mt-1 font-bold">✓</div>
                <span className="text-lg">Entrega gratis en aeropuerto o hotel</span>
              </li>
              <li className="flex items-start gap-3 text-white">
                <div className="w-6 h-6 bg-white text-yellow-700 flex items-center justify-center flex-shrink-0 mt-1 font-bold">✓</div>
                <span className="text-lg">Atención personalizada en tu idioma</span>
              </li>
              <li className="flex items-start gap-3 text-white">
                <div className="w-6 h-6 bg-white text-yellow-700 flex items-center justify-center flex-shrink-0 mt-1 font-bold">✓</div>
                <span className="text-lg">Proceso rápido por WhatsApp</span>
              </li>
              <li className="flex items-start gap-3 text-white">
                <div className="w-6 h-6 bg-white text-yellow-700 flex items-center justify-center flex-shrink-0 mt-1 font-bold">✓</div>
                <span className="text-lg">Vehículos nuevos y limpios</span>
              </li>
              <li className="flex items-start gap-3 text-white">
                <div className="w-6 h-6 bg-white text-yellow-700 flex items-center justify-center flex-shrink-0 mt-1 font-bold">✓</div>
                <span className="text-lg">Soporte 24/7 durante tu viaje</span>
              </li>
            </ul>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-center gap-3 bg-black text-white px-10 py-5 font-semibold text-lg hover:bg-zinc-900 transition-all duration-300 hover:scale-105"
            >
              <MessageCircle className="w-6 h-6" />
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
